import { render } from "./NotificationMessage.vue?vue&type=template&id=0bf59a20&scoped=true"
import script from "./NotificationMessage.vue?vue&type=script&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&lang=js"

import "./NotificationMessage.vue?vue&type=style&index=0&id=0bf59a20&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf59a20"]])

export default __exports__